import type { ComponentType } from 'react';
import { ActivationColorsPreview } from './activation-colors-preview';
import { ActivationNamesPreview } from './activation-names-preview';
import { CellPaddingPreview } from './cell-padding-preview';
import { HeaderThemePreview } from './header-theme-preview';
import { NoyauAccentPreview } from './noyau-accent-preview';
import type { SettingPreviewProps } from './setting-preview-props';
import { StepDecorationPreview } from './step-decoration-preview';

export type { SettingPreviewProps } from './setting-preview-props';

/** The miniature of each visual tweak, keyed by its registry key. */
export const SETTING_PREVIEWS: Readonly<Record<string, ComponentType<SettingPreviewProps>>> = {
  'matrix-noyaux-accent': NoyauAccentPreview,
  'matrix-cell-padding': CellPaddingPreview,
  'matrix-header-theme': HeaderThemePreview,
  'matrix-activation-levier-names': ActivationNamesPreview,
  'matrix-activation-levier-colors': ActivationColorsPreview,
  'singularity-step-decoration': StepDecorationPreview,
};
